<template>
  <div id="app">
    <!-- <keep-alive> -->
        <router-view></router-view>
    <!-- </keep-alive> -->
  </div>
</template>
<script>

window.onload = function () {
  // console.log(window.postMessage);
  // window.parent.postMessage({ msg: 'Hello from web page!' }, '*');
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
}
</script>
<!-- <style lang="scss">
  @import "./assets/styles/cake-variables.scss";
  @import "./assets/styles/variables.scss";
</style> -->
